import {useResourcesToken} from '@/di/di.root-container.hooks';

import cn from 'classnames';

import {Image} from '@/ui/kit/Image/Image';

import s from './FindAppImage.module.css';

interface Props {
  className?: string;
}

export function FindAppImage({className}: Props): JSX.Element {
  const {src, alt} = useResourcesToken().content.FindAppImage;

  return <Image src={src} alt={alt} className={cn(s.root, className)} />;
}
